import { render } from "./PhonePreview.vue?vue&type=template&id=170dda74&scoped=true"
const script = {}

import "./PhonePreview.vue?vue&type=style&index=0&id=170dda74&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-170dda74"]])

export default __exports__